module.exports = __webpack_public_path__ + "static/media/pg.8d36f560.webp";